// extracted by mini-css-extract-plugin
module.exports = {"confirmText":"SettleAuction_confirmText__187Ee","settleAuctionButton":"SettleAuction_settleAuctionButton__1TdsY"};